import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { OFFER_CREATE_PATH } from '@routes/path';
import { useLanguage } from '../../../../contexts/LanguageContext';
import translations from './translations.json';
type SupportedLanguage = keyof typeof translations;

export const DashboardHeader: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;

  const handleGoToAddOffer = () => {
    navigate(OFFER_CREATE_PATH);
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start', 
        mb: 4, 
        gap: 2, 
        flexWrap: 'wrap' 
      }}
    >
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <Typography 
            variant="caption" 
            sx={{ 
              fontWeight: 600, 
              color: '#8c94a4', 
              textTransform: 'uppercase', 
              letterSpacing: '0.05em' 
            }}
          >
            {content.workspace}
          </Typography>
        </Box>
        <Typography 
          variant="h5" 
          sx={{ 
            fontWeight: 800, 
            color: '#ffffff',
            mb: 0.5 
          }}
        >
          {content.title}
        </Typography>
        <Typography sx={{ color: '#8c94a4', fontSize: '0.95rem' }}>
          {content.description}
        </Typography>
      </Box>

      <Box>
        <Button 
          startIcon={<Add />} 
          variant="contained" 
          color="primary"
          onClick={handleGoToAddOffer}
          sx={{
            borderRadius: '8px',
            px: 2.5,
            py: 1,
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            }
          }}
        >
          {content.add}
        </Button>
      </Box>
    </Box>
  );
};